import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Store, StoresState } from '@/types'

export const initialStoresState: StoresState = {
  allStores: [],
}

export const storesSlice = createSlice({
  name: 'store',
  initialState: initialStoresState,
  reducers: {
    setAllStores: (state, action: PayloadAction<Store[]>) => {
      state.allStores = action.payload
    },
  },
})

export const { setAllStores } = storesSlice.actions

export default storesSlice.reducer
